import { RequestConfig, ErrorShowType } from 'umi';

type IErrorConfig = RequestConfig['errorConfig'];
export const errorConfig: IErrorConfig = {
  adaptor: (res, ctx) => {
    // 兼容res 为undefined 或 null
    const resData = res || {};
    const { status } = ctx.res || {}; // 只有http请求失败才有 如http code 400
    if (status !== undefined) {
      return {
        data: resData,
        success: false,
        showType: ErrorShowType.ERROR_MESSAGE,
        errorMessage: resData.message || resData.error,
      };
    }

    // 拦截业务码错误
    // 108404为无优惠券的报错, 不需要提示, 视为正确业务码
    const successCode = [0, 108404]; // 成功的业务码
    if (!successCode.includes(resData?.code)) {
      return {
        data: resData,
        success: false,
        showType: ErrorShowType.WARN_MESSAGE,
        errorCode: resData?.code,
        errorMessage: resData?.message || resData?.error,
      };
    }

    return {
      data: resData,
      success: true,
      showType: ErrorShowType.ERROR_MESSAGE,
      errorMessage: resData?.message || resData?.error,
    };
  },
};
